export const pubnubTimetokenToJsTime = (timetoken: string | number) => {
  return new Date(parseInt(`${timetoken.toString().substring(0, 17 - 4)}`)).getTime(); // timetoken is in microseconds, so we need to remove last 4 digits
}